import clsx from 'clsx'
import classes from './ViewSelector.module.css'
import { ReactComponent as BarChartIcon } from './icons/BarChart.svg'
import { ReactComponent as LineChartIcon } from './icons/LineChart.svg'
import { ReactComponent as TableIcon } from './icons/Table.svg'
import { ReactComponent as ListIcon } from './icons/List.svg'
import { ReactComponent as GridIcon } from './icons/Grid.svg'
import { ReactComponent as WaterfallChartIcon } from './icons/WaterfallChart.svg'
import { useEffect } from 'react'

const OPTIONS = {
  bar: { label: 'Bar Chart', icon: BarChartIcon },
  waterfall: { label: 'Waterfall Chart', icon: WaterfallChartIcon },
  line: { label: 'Line Chart', icon: LineChartIcon },
  table: { label: 'Table', icon: TableIcon },
  list: { label: 'List', icon: ListIcon },
  grid: { label: 'Grid', icon: GridIcon },
} as const

export type OptionKey = keyof typeof OPTIONS

export default function ViewSelector({
  value,
  enabled,
  onChange,
}: {
  value: OptionKey
  enabled: OptionKey[]
  onChange: (value: OptionKey) => void
}) {
  useEffect(() => {
    if (!enabled.includes(value) && enabled.length > 0) {
      onChange(enabled[0])
    }
  }, [value, enabled, onChange])

  return (
    <div className={classes.container}>
      {enabled
        .map((v) => [v, OPTIONS[v]] as const)
        .map(([v, item]) => (
          <div
            key={v}
            className={clsx(classes.item, {
              [classes.selected]: v === value,
            })}
            onClick={() => onChange(v)}
          >
            <item.icon className={classes.icon} title={item.label} />
          </div>
        ))}
    </div>
  )
}
